module.exports = __webpack_public_path__ + "static/media/Flogging_Dawn2.3e81c589.jpg";